module.exports = __webpack_public_path__ + "static/img/daohui_wedding_img2.90030b4.png";